export default __webpack_public_path__ + "static/media/loading-img.9d418098.png";